import { PaginacionProps } from "../global/PaginacionInterface";
import { ExpedienteProps } from "../recepcion/ExpedienteInterface";

export const defaultBuscarLibroPromocionesRecibidasResponse: BuscarLibroPromocionesRecibidasResponse = { currentPageIndex: 0, pageCount: 0, recordCount: 0, records: [], };

export const defaultBuscarLibroPromocionesRecibidas: BuscarLibroPromocionesRecibidas = { idAutoridad: 0, numeroReferencia: '' };

export interface AnexoPromocionRecibidaProps {
    idAnexo:            number;
    tipoAnexo:          string;
    tipoFormato:        string;
    cantidad:           number;
    numeroFojas:        number;
    observaciones:      string;
}

export interface LibroPromocionesRecibidasProps {
    idLibroPromocionRecibida:   number;
    promocion:                  string;
    idExpediente:               number;
    numeroExpediente:           string;
    presentadoPor:              string;
    nombreRecibe:               string;
    observaciones:              string;
    anexos:                     AnexoPromocionRecibidaProps[];
    fechaRecepcion?:            Date;
    expediente:                 ExpedienteProps;
}

export interface BuscarLibroPromocionesRecibidas {
    idAutoridad:        number;
    numeroReferencia:   string;
}

export interface BuscarLibroPromocionesRecibidasParams extends PaginacionProps, BuscarLibroPromocionesRecibidas { }

export interface BuscarLibroPromocionesRecibidasResponse {
    currentPageIndex:   number;
    pageCount:          number;
    recordCount:        number;
    records:            LibroPromocionesRecibidasProps[];
}

export interface GuardarObservaciones {
    id:             number;
    observaciones:  string;
}

export interface DescargarInformacionParams { 
    idAutoridad:        number;
    numeroReferencia:   string;
}